import _ from 'underscore';

let Permissions = null;

export function initialize(options) {
  Permissions = options.globalConfig.get('Permissions');
}

export function updateOdataOptionsForExperiment(options) {
  const isInPilot = _.result(Permissions, 'IsExperimentsEnabled');

  if (isInPilot && options) {
    // eslint-disable-next-line no-param-reassign
    options.custom = options.custom || {};

    _.extendOwn(options.custom, {
      'Campaign/IsExperiment': {
        eq: (val) => {
          const operator = val ? 'gt' : 'le';

          return `Campaign/ExperimentId ${operator} 0`;
        },
      },
    });
  }
}
